import { Links, Meta, Scripts, ScrollRestoration } from 'react-router';

import { ColorModeScript } from '@chakra-ui/react';

import '@fontsource-variable/inter';

import AppLayout from './app-layout';

import './index.css';

import { AppProvider } from './providers/AppProvider';
import { theme } from './theme';
import cookies from './utils/cookies';

export function Layout({ children }: { children: React.ReactNode }) {
  const colorMode = (cookies.getCookie('chakra-ui-color-mode') ?? 'dark') as
    | 'light'
    | 'dark';

  return (
    <html lang='en' data-theme={colorMode} style={{ colorScheme: colorMode }}>
      <head>
        <meta charSet='UTF-8' />
        <link
          rel='icon'
          type='image/png'
          href='https://uploads-ssl.webflow.com/66556ea0d84d2ab9eb070fa2/6656c817567c6f2ed8b6fe25_favicon-32x32.png'
        />
        <meta name='viewport' content='width=device-width, initial-scale=1.0' />
        <meta name='format-detection' content='address=no' />
        <title>VH3 AI</title>
        <ColorModeScript initialColorMode={theme.config.initialColorMode} />
        <Meta />
        <Links />
      </head>
      <body className={`chakra-ui-${colorMode}`}>
        <div id='popups'></div>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export default function Root() {
  return (
    <AppProvider>
      <AppLayout />
    </AppProvider>
  );
}
